import { Image, StyleSheet, Text, View } from "@react-pdf/renderer";

import React from "react";

import draftLogo from "@/assets/images/draftLogo.png";
import PDFPortrait from "@/components/Common/PDFs/PDFPortrait";
import PDFHeaderGlobo from "@/pages/Globo/Components/PDFHeaderGlobo";

const styles = StyleSheet.create({
  page: {
    /*  paddingTop: 60,
     paddingHorizontal: 60,
     fontSize: 10,
     lineHeight: 1.6, */
    position: "relative",
  },
  watermark: {
    position: "absolute",
    top: "-20%",
    left: "-5%",
    width: 600,
    opacity: 0.3,
    zIndex: -1,
  },

  header: {
    marginBottom: 0,
  },
  dateSection: {
    fontSize: 10,
    marginBottom: 20,
  },
  greeting: {
    fontSize: 10,
    marginBottom: 15,
  },
  paragraph: {
    fontSize: 10,
    marginBottom: 10,
    lineHeight: 1.5,
    textAlign: "justify",
  },
  bold: {
    fontWeight: "bold",
  },
  tableTitle: {
    fontSize: 10,
    fontWeight: "bold",
    backgroundColor: "#8B7BA8",
    color: "#FFFFFF",
    padding: 5,
    marginTop: 15,
    marginBottom: 0,
  },
  table: {
    width: "100%",
    borderLeft: "0.5pt solid #000",
    borderRight: "0.5pt solid #000",
    borderBottom: "1pt solid #000",
  },
  tableRow: {
    flexDirection: "row",
    borderTop: "0.5pt solid #000",
  },
  tableCell: {
    fontSize: 9,
    padding: 5,
    borderRight: "0.5pt solid #000",
  },
  tableCellLeft: {
    width: "40%",
  },
  tableCellRight: {
    width: "60%",
  },
  tableCellLast: {
    borderRight: "none",
  },
  footerText: {
    fontSize: 10,
    marginTop: 20,
    marginBottom: 15,
    lineHeight: 1.5,
    textAlign: "justify",
  },
  preparedBy: {
    fontSize: 10,
    marginTop: 30,
    marginBottom: 10,
  },
  note: {
    fontSize: 10,
    fontWeight: "bold",
    marginTop: 10,
  },
});

const formatDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  return date.toLocaleDateString("en-US", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};

const formatShortDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  return `(${date.toLocaleDateString("en-US", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  })})`;
};

const LoaPDF = ({ pdfTitle, data }) => {
  return (
    <PDFPortrait pdfTitle={pdfTitle} Header={PDFHeaderGlobo} Footer={() => null}>
      <View style={styles.page}>
        {data?.statusName !== "Approved" && <Image src={draftLogo} style={styles.watermark} fixed />}

        <View style={styles.header}>
          <Text style={styles.dateSection}>Date: {formatDate(data?.dateSubmitted || data?.createdDate)}</Text>
          <Text style={styles.greeting}>
            Dear Healthcare Partner: <Text style={styles.bold}>{data?.purchasingAccountName}</Text>
          </Text>
          <Text style={styles.paragraph}>
            Kindly dispense <Text style={styles.bold}>{data?.productName}</Text> to the following patient as indicated below:
          </Text>
        </View>

        <Text style={styles.tableTitle}>Patient Information</Text>
        <View style={styles.table}>
          <View style={styles.tableRow}>
            <Text style={[styles.tableCell, styles.tableCellLeft]}>Name</Text>
            <Text style={[styles.tableCell, styles.tableCellRight, styles.tableCellLast]}>{data?.patientName}</Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={[styles.tableCell, styles.tableCellLeft]}>Patient Code</Text>
            <Text style={[styles.tableCell, styles.tableCellRight, styles.tableCellLast]}>{data?.patientCode}</Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={[styles.tableCell, styles.tableCellLeft]}>Hospital</Text>
            <Text style={[styles.tableCell, styles.tableCellRight, styles.tableCellLast]}>{data?.hospitalName || "—"}</Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={[styles.tableCell, styles.tableCellLeft]}>Physician</Text>
            <Text style={[styles.tableCell, styles.tableCellRight, styles.tableCellLast]}>{data?.doctorName}</Text>
          </View>
        </View>

        <Text style={styles.tableTitle}>Program Access Scheme</Text>
        <View style={styles.table}>
          <View style={styles.tableRow}>
            <Text style={[styles.tableCell, styles.tableCellLeft]}>LOA No.</Text>
            <Text style={[styles.tableCell, styles.tableCellRight, styles.tableCellLast]}>{data?.referenceNo}</Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={[styles.tableCell, styles.tableCellLeft]}>Product Item/s</Text>
            <Text style={[styles.tableCell, styles.tableCellRight, styles.tableCellLast]}>{data?.productName}</Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={[styles.tableCell, styles.tableCellLeft]}>Scheme</Text>
            <Text style={[styles.tableCell, styles.tableCellRight, styles.tableCellLast]}>{data?.scheme || "—"}</Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={[styles.tableCell, styles.tableCellLeft]}>Commercial Reference</Text>
            <Text style={[styles.tableCell, styles.tableCellRight, styles.tableCellLast]}>{data?.commercialReference || "—"}</Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={[styles.tableCell, styles.tableCellLeft]}>Total Quantity</Text>
            <Text style={[styles.tableCell, styles.tableCellRight, styles.tableCellLast]}>
              {data?.quantity} {data?.uom}
            </Text>
          </View>
        </View>

        <Text style={styles.footerText}>
          <Text style={styles.bold}>Instructions: Important note to subdistributor: </Text>
          Please release the quantity of FOC/s reflected above. This LOA is valid <Text style={styles.bold}>15 days</Text> from date of release. This
          LOA is unique per patient. Only patients with accomplished LEAP Form are entitled to receive the free goods.
        </Text>

        <Text style={styles.preparedBy}>
          Requested by: <Text style={styles.bold}>{data?.submittedByName}</Text> ({formatShortDate(data?.dateSubmitted)})
        </Text>

        <Text style={styles.preparedBy}>
          Approved by: <Text style={styles.bold}>{data?.approvedByName || "___________________"}</Text> (
          {data?.dateApproved ? formatShortDate(data?.dateApproved) : "dd-mmm-yyyy"})
        </Text>
      </View>
    </PDFPortrait>
  );
};

export default React.memo(LoaPDF);
